// extracted by mini-css-extract-plugin
export default {"trigger":"BusinessMenu_trigger__SD8Gl","dropdown":"BusinessMenu_dropdown__Cn+7q"};